export default "__VITE_ASSET__qgYd1gqr__"